define("checkout/components/seamless-checkout/feature-banner", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _getMorePostsBannerText;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.text}}
    <div class="cIC--card tCH--banner__alt">
      <div class="cIC--cardHeader">
        <p class="cIC--cardHeader__title">{{this.text}}</p>
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "j7bvrPBe",
    "block": "[[[41,[30,0,[\"text\"]],[[[1,\"  \"],[10,0],[14,0,\"cIC--card tCH--banner__alt\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cIC--cardHeader\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,[30,0,[\"text\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\"]]",
    "moduleName": "checkout/components/seamless-checkout/feature-banner.hbs",
    "isStrictMode": false
  });
  let FeatureBannerComponent = _exports.default = (_class = (_getMorePostsBannerText = /*#__PURE__*/new WeakMap(), class FeatureBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateFieldInitSpec(this, _getMorePostsBannerText, {
        get: _get_getMorePostsBannerText,
        set: void 0
      });
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor2, this);
    }
    get featureActionsList() {
      return this.seamlessCheckoutManager.featureActionsList;
    }
    get featureMapList() {
      return this.seamlessCheckoutManager.featureMapList;
    }
    get planName() {
      return this.intl.t(`plans.plan_names.${this.args.plan.planType}`);
    }
    get text() {
      const {
        feature
      } = this.args;
      if (!feature) {
        return '';
      }

      // Note: one-off banners:
      if (feature == 'getMorePosts') {
        return _classPrivateFieldGet(this, _getMorePostsBannerText);
      }
      if (feature == 'user') {
        return this.intl.t('checkout.feature_banner.addons', {
          feature: this.intl.t('shared_words.users')
        });
      }
      if (feature == 'socialSet') {
        return this.intl.t('checkout.feature_banner.addons', {
          feature: this.intl.t('shared_words.social_sets')
        });
      }
      const additionalAiCreditFeatures = ['aiCredits', 'aiCreditsOneBundle', 'aiCreditsTwoBundles'];
      if (additionalAiCreditFeatures.includes(feature)) {
        return this.intl.t('checkout.feature_banner.addons', {
          feature: this.intl.t('shared_words.credits')
        });
      }
      if (feature == 'additionalAiCreditsOnGrowth') {
        return this.intl.t('checkout.feature_banner.add_credits');
      }

      // featureMapList requires the banner to be generated from the featureName
      if (this.featureMapList[feature]?.featureName) {
        return this.intl.t('checkout.feature_banner.get_feature_on_plan', {
          feature: this.featureMapList[feature]?.featureName,
          plan: this.planName
        });
      }
      return '';
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  function _get_getMorePostsBannerText() {
    const {
      socialProfileType,
      plan
    } = this.args;
    const numPosts = plan.numberOfPosts === -1 ? this.intl.t('plans.feature_mappings.unlimited').toLowerCase() : plan.numberOfPosts;
    const postType = socialProfileType ? this.intl.t(`shared_phrases.post_types.${socialProfileType}`) : this.intl.t(`shared_phrases.post_types.default`);
    const featureName = this.intl.t('checkout.feature_banner.num_posts_per_month', {
      numPosts,
      postType
    });
    return this.intl.t('checkout.feature_banner.get_feature_on_plan', {
      feature: featureName,
      plan: this.planName
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FeatureBannerComponent);
});